import { render, staticRenderFns } from "./UniversalSelector.vue?vue&type=template&id=6a9ff049&scoped=true&"
import script from "./UniversalSelector.vue?vue&type=script&lang=js&"
export * from "./UniversalSelector.vue?vue&type=script&lang=js&"
import style0 from "./UniversalSelector.vue?vue&type=style&index=0&id=6a9ff049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ff049",
  null
  
)

export default component.exports